import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, Grid, List, ListItem, ListItemText } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';

import { selectCurrentDevice } from '../../features/location/locationSlice';

import { makeStyles } from '@mui/styles';
import {
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';
import { useDeleteDeviceMutation } from 'api/location.api';
import { useDispatch, useSelector } from 'react-redux';

const Device = (props) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      flex: '0.2',
      minWidth: '200px',
    },
    margin: {
      margin: theme.spacing(1),
    },
    listLabel: {
      flex: '0.2',
      minWidth: '150px',
      align: 'left',
      fontSize: '16px',
      fontWeight: 700,
    },
    maskedInput: {
      minHeight: '50px',
      paddingLeft: '10px',
    },
    listData: {
      flex: '0.2',
      minWidth: '400px',
      align: 'left',
    },
    referenceListItem: {
      flex: '0.2',
      minWidth: '600px',
      align: 'left',
      paddingLeft: '150px',
    },
    grid: {
      height: '40vh',
      padding: '10px',
      paddingRight: '80px',
      paddingLeft: '40px',
    },
    buttonbar: {
      '& > *': {
        margin: theme.spacing(1),
        float: 'right',
      },
    },
  }));

  const dispatch = useDispatch();

  const classes = useStyles();

  const device = useSelector(selectCurrentDevice);
  const [deleteDevice] = useDeleteDeviceMutation();

  const references = () => {
    const refs = device.references.map((ref, key) => {
      return (
        <ListItem alignItems='flex-start'>
          <ListItemText
            className={classes.referenceListItem}
            primary={ref.type + ' ' + ref.id + ', ' + ref.description}
          />
        </ListItem>
      );
    });
    return refs;
  };

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDelete = async () => {
    await deleteDevice(device._id).unwrap();
    props.handleCloseAndRefresh();
  };

  const deviceIdRow = (device) => {
    let labelValueProp = {
      Workstation: {
        label: 'Workstation ID',
        value: 'workstation_id',
      },
      Cashdrawer: {
        label: 'Cash drawer ID',
        value: 'cashdrawer_id',
      },
      Safe: {
        label: 'Safe ID',
        value: 'cashdrawer_id',
      },
    };

    return Object.keys(labelValueProp).includes(device.type) ? (
      <ListItem alignItems='flex-start'>
        <ListItemText
          className={classes.listLabel}
          primary={`${labelValueProp[device.type].label}:`}
          disableTypography
        />
        <ListItemText
          className={classes.listData}
          primary={device[labelValueProp[device.type].value]}
        />
      </ListItem>
    ) : null;
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='lg'
      >
        <DialogTitle id='form-dialog-title'>Device Definition</DialogTitle>
        <DialogContent>
          <Grid
            container
            justifyContent='space-around'
            spacing={1}
            className={classes.grid}
          >
            <Grid item xs={1} />
            <Grid item xs={11}>
              <List aria-label='device summary'>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Type:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.type}
                  />
                </ListItem>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Location:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.location}
                  />
                </ListItem>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Device:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.name}
                  />
                </ListItem>
                {deviceIdRow(device)}
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Description:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.description}
                  />
                </ListItem>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Brand:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.brand}
                  />
                </ListItem>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Model:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.model}
                  />
                </ListItem>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Status:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={device.status}
                  />
                </ListItem>
                {device.managing_agent ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='Managing Agent:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.managing_agent}
                    />
                  </ListItem>
                ) : null}
                {device.alias ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='Alias:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.alias}
                    />
                  </ListItem>
                ) : null}
                {device.serial_number ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='Serial Number:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.serial_number}
                    />
                  </ListItem>
                ) : null}
                {device.proxy_device_id ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='Proxy Device:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.proxy_description}
                    />
                  </ListItem>
                ) : null}
                {device.registration_code ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='Registration Code:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.registration_code}
                    />
                  </ListItem>
                ) : null}
                {device.ip_address ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='IP Address:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.ip_address}
                    />
                  </ListItem>
                ) : null}
                {device.shared ? (
                  <ListItem alignItems='flex-start'>
                    <ListItemText
                      className={classes.listLabel}
                      primary='Shared?:'
                      disableTypography
                    />
                    <ListItemText
                      className={classes.listData}
                      primary={device.shared ? 'Yes' : 'No'}
                    />
                  </ListItem>
                ) : null}
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Created:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={new Date(device.created_at).toLocaleString()}
                  />
                </ListItem>
                <ListItem alignItems='flex-start'>
                  <ListItemText
                    className={classes.listLabel}
                    primary='Last Used:'
                    disableTypography
                  />
                  <ListItemText
                    className={classes.listData}
                    primary={
                      device.last_used
                        ? new Date(device.last_used).toLocaleString()
                        : 'Never'
                    }
                  />
                </ListItem>
                {device.references && device.references.length > 0 ? (
                  <>
                    <ListItem onClick={handleClick}>
                      <ListItemText
                        className={classes.listLabel}
                        primary='References:'
                        disableTypography
                      />
                      {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={open} timeout='auto' unmountOnExit>
                      <List component='div' disablePadding>
                        {references()}
                      </List>
                    </Collapse>
                  </>
                ) : null}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {device.allowDelete ? (
            device.last_used ? (
              <ThemedPrimaryBtn onClick={handleDelete}>
                Archive
              </ThemedPrimaryBtn>
            ) : (
              <ThemedPrimaryBtn onClick={handleDelete}>Delete</ThemedPrimaryBtn>
            )
          ) : null}
          <ThemedSecondaryBtn onClick={props.handleClose}>
            Close
          </ThemedSecondaryBtn>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Device;
